import React from "react";

const alertStatusToStatus = alertStatus => {
  return alertStatus === 0 ? 0 : alertStatus + 1;
};

export const idStatusToText = (classes, statusId, alertStatus) => {
  let txt;
  const status = statusId === 0 ? alertStatusToStatus(alertStatus) : statusId;

  switch (status) {
    case 0:
      txt = "En vente";
      break;
    case 1:
      txt = "En pause";
      break;
    case 2:
      txt = "Consommable à vérifier";
      break;
    case 3:
      txt = "Composant à vérifier";
      break;
    case 4:
      txt = "Hors ligne";
      break;
    default:
      txt = "Statut inconnu";
      break;
  }
  return <span className={statusToClass(status, classes)}>{txt}</span>;
};

const statusToClass = (status, classes) => {
  switch (status) {
    case 0:
      return classes.selling;
    case 1:
      return classes.pause;
    case 2:
      return classes.errorNonFatal;
    case 3:
      return classes.errorFatal;
    case 4:
      return classes.offline;
    default:
      return classes.unknown;
  }
};



// WEBPACK FOOTER //
// ./src/lib/kioskPresentation.js